import styled from 'styled-components';
import { layout } from '../../config/styles';

export const ContainerRight = styled.div`
  float: right;
  width: 300px;
  height: calc(100vh - ${layout.headerHeight}px);
  background-color: #f2f5fc;
`;

export const ChannelHeader = styled.div`
  height: ${layout.channelHeaderHeight}px;
  border-left: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding: 14px 12px;
`;

export const WorkspaceName = styled.span`
  width: 216px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  float: left;
  margin-top: 0.4em;
`;

export const ChatContent = styled.div`
  background-color: #ffffff;
  height: calc(100% - ${layout.channelHeaderHeight}px);
`;
